export default __webpack_public_path__ + "assets/favicon-okc-premium.49714fa2.png";